import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CopyLinkComponent } from './copy-link/copy-link.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
  declarations: [CopyLinkComponent],
  exports: [CopyLinkComponent],
})
export class SharedUiCopyLinkModule {}
